export default [
  {
    path: '/takeCoupon',
    name: 'takeCoupon',
    component: () => import('@/views/takeCoupon/takeCoupon'),
    meta: {
      roles: ['distributor', 'customer'],
    },
  },
]
